import React, { Fragment, useEffect } from 'react';
import { Col, Card, CardBody, CardHeader, CardFooter, Row, FormGroup, Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { H6, LI, UL, P, Btn, Badges } from '../../../../AbstractElements';
import formatPhoneNumber from '../../../../Component/Learning/Common/GenerateContent/FormatPhoneNumber';
import Moment from 'moment';

const TentorDetailGeneral = () => {
    const detail = useSelector(state => state.Tentor.detail);
    console.log(detail?.created_at)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <Fragment>
            <Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
                <Card className="social-widget-card">
                    <CardHeader>
                        <Col>
                            <Row>
                                <Col>
                                    {detail.status && detail.status === "inactive" && (
                                        <Badges attrBadge={{ color: "danger" }}>Tidak Aktif</Badges>
                                    )}
                                    <h5>{detail.name || 'Nama Tentor'}</h5>
                                </Col>
                            </Row>
                        </Col>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col sm="2" xl="2" lg="2">
                                <img src={detail.photo} alt="banner" className="img-fluid rounded"
                                    style={{
                                        width: '150px',
                                        height: 'auto',
                                        filter: detail.status === "inactive" ? "grayscale(100%)" : "none"
                                    }} />
                            </Col>
                            <Col sm="10" xl="10" lg="10">
                                <FormGroup>
                                    <Label className="form-label"><b>Materi Ajar:</b></Label>
                                    <Input readOnly className="form-control" defaultValue={detail.mastered_fields} />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label className="form-label"><b>Nomer Telepon:</b></Label>
                                    <Input readOnly className="form-control" defaultValue={formatPhoneNumber(detail.phone)} />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label className="form-label"><b>Alamat Email:</b></Label>
                                    <Input readOnly className="form-control" defaultValue={detail.email || 'Email belum dilengkapi'} />
                                </FormGroup>
                                <Row>
                                    <Col>
                                        <Label className="form-label"><b>Pendidikan:</b></Label>
                                        {detail?.education && detail?.education.length > 0 ? (
                                            <UL attrUl={{ className: 'list-unstyled mt-2 mb-0' }}>
                                                {detail.education.map((item, index) => (
                                                    <LI key={`education-${index}`} attrLI={{ className: 'd-flex mb-2' }}>{item}</LI>
                                                )
                                                )}
                                            </UL>
                                        ) : (
                                            <P attrP={{ className: 'mb-0 font-roboto' }}><b>Tidak ada pendidikan.</b></P>
                                        )}
                                    </Col>
                                    <Col>
                                        <Label className="form-label"><b>Pengalaman:</b></Label>
                                        {detail?.experience && detail?.experience.length > 0 ? (
                                            <UL attrUl={{ className: 'list-unstyled mt-2 mb-0' }}>
                                                {detail.experience.map((item, index) => (
                                                    <LI key={`experience-${index}`} attrLI={{ className: 'd-flex mb-2' }}>{item}</LI>
                                                )
                                                )}
                                            </UL>
                                        ) : (
                                            <P attrP={{ className: 'mb-0 font-roboto' }}><b>Tidak ada pengalaman.</b></P>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <Row>
                            <Col>
                                <H6 attrH6={{ className: 'font-roboto' }}>Created at: {Moment(detail?.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail?.created_at).format('HH:mm:ss')} WIB</H6>
                                <H6 attrH6={{ className: 'font-roboto' }}>Updated at: {Moment(detail?.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail?.updated_at).format('HH:mm:ss')} WIB</H6>
                            </Col>
                            <Col className='text-end'>
                                <Link to={`${process.env.PUBLIC_URL}/classes/tentor/edit/${detail.id}`}>
                                    <Btn attrBtn={{ color: 'success', className: 'btn btn-primary m-r-10' }}>
                                        <i className="fa fa-edit fa-lg me-2"></i>Edit
                                    </Btn>
                                </Link>
                                <Link to={`${process.env.PUBLIC_URL}/classes/tentor-list`}>
                                    <Btn attrBtn={{ color: 'warning', className: 'btn btn-primary m-r-10' }}>
                                        <i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
                                    </Btn>
                                </Link>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </Col>
        </Fragment >
    );
};
export default TentorDetailGeneral;